// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3PhC2","header":"ClearentDisclaimer_header__1W12j","inner":"ClearentDisclaimer_inner__QnKEB"};